import React from 'react';
import { useSelector } from "react-redux";
import { AES } from 'crypto-js';
import { Link } from 'react-router-dom';
import "./VendorOverviewListingRecenInvoices.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useFetchVendorInvoices } from '../VendorInvoice/useVendorInvoice';
import { dateVenInvConvert } from '../../../helpers/dateHelper';
import invStatusConsts from "../../../constants/invStatusConsts";

export function detailCTA(rowData) {
  const encryptedId = AES.encrypt(rowData._id, 'encryptionKey').toString();
  const encryptedCliId = AES.encrypt(rowData.ven_inv_for._id, 'encryptionKey').toString();
  const invId = encodeURIComponent(encryptedId).replace(/\//g, '%2F');
  const encodedId = encodeURIComponent(encryptedCliId).replace(/\//g, '%2F');

  return (
    <Link to={`../invoices/view/${invId}/${encodedId}`} className="cta-link">
      Details
    </Link>
  );
}

const formatCurrency = (value) => {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);
}

const RecentInvoices = (props) => {

  let token = null;
  const { user } = useSelector((state) => state.auth);
  if (user) {
    if (user && user.token) {
      token = user.token;
    }
  }

  const { data: vendorInvoiceList = [], isLoading, refetch: refetchVendorInvoiceList, isError } = useFetchVendorInvoices(props.id, token);

  const renderStatus = (rowData) => {
    // Determine the class based on the payment_status value
    let statusClass;
    let statusName;
    if (rowData.ven_inv_status === invStatusConsts.Approved) {
      statusClass = "manual";
      statusName = "Approved";
    } else if (rowData.ven_inv_status === invStatusConsts.Not_Reviewed) {
      statusClass = "pending";
      statusName = "Not Reviewed";
    } else if (rowData.ven_inv_status === invStatusConsts.Rejected) {
      statusClass = "overdue";
      statusName = "Rejected";
    } else if (rowData.ven_inv_payment_status === invStatusConsts.Cancelled) {
      statusClass = "overdue";
      statusName = "Cancelled";
    }
    return (
      <span className={`payment-status ${statusClass}`}>{statusName}</span>
    );
  };

  const renderAmount = (rowData) => {
    var totalAmount = rowData.ven_inv_total_amount.toLocaleString("en-US", {
      style: "currency",
      currency: rowData.ven_inv_currency,
    });

    return <span> {totalAmount}</span>;
  };

  return (
    <div className="listing-recent-invoice-inner">
      <div className="table-head-outer">
        <div className="table-head">
          Recent Invoices
        </div>
        <div className="view-button">
          <Link to={`/vendor/invoices/${encodeURIComponent(AES.encrypt(props.id, 'encryptionKey').toString().replace(/\//g, '%2F'))}`} className={window.location.pathname.startsWith('/vendor/invoices') ? 'active' : ''}>
            View All
          </Link>
        </div>
      </div>
      {isLoading ? (
        <div className="vendor-invoice-skeleton-table">
          <table className="p-datatable-table" style={{ width: "100%", borderSpacing: 0 }}>
            <thead className="p-datatable-thead">
              <tr>
                <th style={{ 
                  textAlign: "left", 
                  padding: "11px 0px", 
                  background: "#F5F6F8", 
                  fontWeight: 500, 
                  fontSize: "17px", 
                  lineHeight: "21px", 
                  color: "#6A7988",
                  paddingLeft: "22px",
                  borderTopLeftRadius: "10px"
                }}>
                  Invoice ID
                </th>
                <th style={{ 
                  textAlign: "left", 
                  padding: "11px 0px", 
                  background: "#F5F6F8", 
                  fontWeight: 500, 
                  fontSize: "17px", 
                  lineHeight: "21px", 
                  color: "#6A7988"
                }}>
                  Due Date
                </th>
                <th style={{ 
                  textAlign: "left", 
                  padding: "11px 0px", 
                  background: "#F5F6F8", 
                  fontWeight: 500, 
                  fontSize: "17px", 
                  lineHeight: "21px", 
                  color: "#6A7988"
                }}>
                  Status
                </th>
                <th style={{ 
                  textAlign: "left", 
                  padding: "11px 0px", 
                  background: "#F5F6F8", 
                  fontWeight: 500, 
                  fontSize: "17px", 
                  lineHeight: "21px", 
                  color: "#6A7988"
                }}>
                  Amount
                </th>
                <th style={{ 
                  textAlign: "left", 
                  padding: "11px 0px", 
                  background: "#F5F6F8", 
                  fontWeight: 500, 
                  fontSize: "17px", 
                  lineHeight: "21px", 
                  color: "#6A7988",
                  paddingRight: "20px",
                  borderTopRightRadius: "10px"
                }}>
                </th>
              </tr>
            </thead>
            <tbody className="p-datatable-tbody">
              {Array.from({ length: 5 }).map((_, index) => (
                <tr key={`skeleton-row-${index}`}>
                  {/* Invoice ID */}
                  <td style={{ 
                    paddingLeft: "22px", 
                    paddingTop: "19px", 
                    paddingBottom: "22px", 
                    borderBottom: "0.5px solid #D8DDEE",
                    width: "25.8%"
                  }}>
                    <div
                      style={{
                        width: "100px",
                        height: "22px",
                        backgroundColor: "#e5e7eb",
                        borderRadius: "4px",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    />
                  </td>
                  {/* Due Date */}
                  <td style={{ 
                    paddingTop: "19px", 
                    paddingBottom: "22px", 
                    borderBottom: "0.5px solid #D8DDEE",
                    width: "26.4%"
                  }}>
                    <div
                      style={{
                        width: "120px",
                        height: "22px",
                        backgroundColor: "#e5e7eb",
                        borderRadius: "4px",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    />
                  </td>
                  {/* Status */}
                  <td style={{ 
                    paddingTop: "19px", 
                    paddingBottom: "22px", 
                    borderBottom: "0.5px solid #D8DDEE",
                    width: "27.8%"
                  }}>
                    <div
                      style={{
                        width: "100px",
                        height: "31px",
                        backgroundColor: "#e5e7eb",
                        borderRadius: "100px",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    />
                  </td>
                  {/* Amount */}
                  <td style={{ 
                    paddingTop: "19px", 
                    paddingBottom: "22px", 
                    borderBottom: "0.5px solid #D8DDEE",
                    width: "14.3%",
                    fontWeight: 500
                  }}>
                    <div
                      style={{
                        width: "90px",
                        height: "22px",
                        backgroundColor: "#e5e7eb",
                        borderRadius: "4px",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    />
                  </td>
                  {/* Details */}
                  <td style={{ 
                    paddingRight: "20px", 
                    paddingTop: "19px", 
                    paddingBottom: "22px", 
                    borderBottom: "0.5px solid #D8DDEE"
                  }}>
                    <div
                      style={{
                        width: "60px",
                        height: "22px",
                        backgroundColor: "#e5e7eb",
                        borderRadius: "4px",
                        animation: "pulse 1.5s ease-in-out infinite",
                        marginLeft: "auto"
                      }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <style>{`
            @keyframes pulse {
              0%, 100% {
                opacity: 1;
              }
              50% {
                opacity: 0.5;
              }
            }
          `}</style>
        </div>
      ) : (
        <DataTable
          value={vendorInvoiceList.slice(0, 5)}
          removableSort
          tableStyle={{ minWidth: "50rem", width: "100%", textAlign: "left" }}
          paginator={false}
          paginatorClassName="recent-invoices-pagination"
          rows={5}
          emptyMessage="No invoices found under this vendor"
        >
          <Column
            field="ven_inv_number"
            header="Invoice ID"
            sortable
            style={{ width: "25.8%" }}
          ></Column>
          <Column
            field="ven_inv_due_date"
            body={dateVenInvConvert}
            header="Due Date"
            sortable
            style={{ width: "26.4%" }}
          ></Column>
          <Column
            field="ven_inv_status"
            header="Status"
            body={renderStatus}
            sortable
            style={{ width: "27.8%" }}
          ></Column>
          <Column
            field="ven_inv_total_amount"
            header="Amount"
            body={renderAmount}
            sortable
            style={{ width: "14.3%" }}
            className="bold-td"
          ></Column>
          <Column
            field="_id"
            body={detailCTA}
            style={{ paddingRight: "20px"}}
          ></Column>
        </DataTable>
      )}
    </div>
  );

};
export default RecentInvoices;